import { REQUEST, SUCCESS, FAILURE } from '../../actions/constants'
import {
  LOAD_SB_POST_DATA,
  LOAD_SB_CATEGORY_DATA,
  RESET_SB_CATEGORY_DATA,
  LOAD_SB_AUTHOR_DATA,
  RESET_SB_AUTHOR_DATA,
  LOAD_SB_CATEGORIES_DATA,
  LOAD_SB_POST_LIST_BY_GROUP_DATA,
  LOAD_SB_FEATURED_DATA,
  // LOAD_SB_MOST_POPULAR_POSTS_DATA,
  LOAD_SB_LATEST_POSTS_DATA,
  LOAD_SB_BLOG_HOME_DATA,
  LOAD_SB_RELATED_POSTS_DATA,
} from './actions'


const initialState = {
  isFetchingPost: false,
  storyblokPost: null,

  isFetchingCategory: false,
  storyblokCategory: null,

  isFetchingAuthor: false,
  storyblokAuthor: null,

  isFetchingCategoriesList: false,
  storyblokCategoriesList: null,

  isFetchingPostList: false,
  storyblokPostList: null,
  postListPagination: {
    total: '',
    perPage: '',
  },

  isFetchingBlogHome: false,
  storyblokBlogHomeData: null,

  isFetchingFeaturedPost: false,
  featuredPost: null,

  // isFetchingPopularPostList: false,
  // popularPostList: null,

  isFetchingLatestPostList: false,
  latestPostList: null,
  latestPostListPagination: {
    total: 0,
    perPage: 0,
    currentPage: 1,
  },

  relatedPostsList: null,
  isFetchingRelatedPostList: false,
}

function storyblokReducer(state = initialState, action) {
  const reducerState = Object.assign({}, state)
  let responseData

  switch(action.type) {
    // Store blog post page data ////////////////////////////////////
    case LOAD_SB_POST_DATA[REQUEST]:
      reducerState.storyblokPost = null
      reducerState.isFetchingPost = true
      break
    case LOAD_SB_POST_DATA[SUCCESS]:
      responseData = action.response && action.response.data
      reducerState.storyblokPost = responseData && responseData.story
      reducerState.isFetchingPost = false
      break
    case LOAD_SB_POST_DATA[FAILURE]:
      reducerState.storyblokPost = null
      reducerState.isFetchingPost = false
      break

    // Store blog category page data ////////////////////////////////
    case LOAD_SB_CATEGORY_DATA[REQUEST]:
      reducerState.storyblokCategory = null
      reducerState.isFetchingCategory = true
      break
    case LOAD_SB_CATEGORY_DATA[SUCCESS]:
      responseData = action.response && action.response.data
      reducerState.storyblokCategory = responseData && responseData.story
      reducerState.isFetchingCategory = false
      break
    case LOAD_SB_CATEGORY_DATA[FAILURE]:
      reducerState.storyblokCategory = null
      reducerState.isFetchingCategory = false
      break

    case RESET_SB_CATEGORY_DATA:
      reducerState.storyblokCategory = null
      reducerState.featuredPost = null
      reducerState.storyblokPostList = null
      break


    // Store blog author page data ////////////////////////////////
    case LOAD_SB_AUTHOR_DATA[REQUEST]:
      reducerState.storyblokAuthor = null
      reducerState.isFetchingAuthor = true
      break
    case LOAD_SB_AUTHOR_DATA[SUCCESS]:
      responseData = action.response && action.response.data
      reducerState.storyblokAuthor = responseData && responseData.story
      reducerState.isFetchingAuthor = false
      break
    case LOAD_SB_AUTHOR_DATA[FAILURE]:
      reducerState.storyblokAuthor = null
      reducerState.isFetchingAuthor = false
      break

    case RESET_SB_AUTHOR_DATA:
      reducerState.storyblokAuthor = null
      reducerState.featuredPost = null
      reducerState.storyblokPostList = null
      break

    // Store all categories list data  //////////////////////////////
    case LOAD_SB_CATEGORIES_DATA[REQUEST]:
      reducerState.storyblokCategoriesList = null
      reducerState.isFetchingCategoriesList = true
      break
    case LOAD_SB_CATEGORIES_DATA[SUCCESS]:
      responseData = action.response && action.response.data
      reducerState.storyblokCategoriesList = responseData && responseData.stories
      reducerState.isFetchingCategoriesList = false
      break
    case LOAD_SB_CATEGORIES_DATA[FAILURE]:
      reducerState.storyblokCategoriesList = null
      reducerState.isFetchingCategoriesList = false
      break

    // Store all blog posts by category list data ///////////////////
    case LOAD_SB_POST_LIST_BY_GROUP_DATA[REQUEST]:
      reducerState.storyblokPostList = null
      reducerState.isFetchingPostList = true
      break
    case LOAD_SB_POST_LIST_BY_GROUP_DATA[SUCCESS]:
      responseData = action.response && action.response.data

      const newPostListPagination = { ...reducerState.postListPagination }
      if(action.response && action.response.headers) {
        newPostListPagination.total = action.response.headers.total
        newPostListPagination.perPage = action.response.headers['per-page']
      }
      reducerState.postListPagination = newPostListPagination
      reducerState.storyblokPostList = responseData && responseData.stories
      reducerState.isFetchingPostList = false
      break
    case LOAD_SB_POST_LIST_BY_GROUP_DATA[FAILURE]:
      reducerState.storyblokPostList = null
      reducerState.isFetchingPostList = false
      break

    // Store featured post by category data ///////////////////
    case LOAD_SB_FEATURED_DATA[REQUEST]:
      reducerState.isFetchingFeaturedPost = true
      reducerState.featuredPost = null
      break
    case LOAD_SB_FEATURED_DATA[SUCCESS]:
      responseData = action.response && action.response.data
      reducerState.featuredPost =
        responseData && responseData.stories && responseData.stories.length ? responseData.stories[0] : null
      reducerState.isFetchingFeaturedPost = false
      break
    case LOAD_SB_FEATURED_DATA[FAILURE]:
      reducerState.isFetchingFeaturedPost = false
      break

    // Store blog home page data - the static part coming from storyblok
    case LOAD_SB_BLOG_HOME_DATA[REQUEST]:
      reducerState.isFetchingBlogHome = true
      reducerState.storyblokBlogHomeData = null
      break
    case LOAD_SB_BLOG_HOME_DATA[SUCCESS]:
      reducerState.isFetchingBlogHome = false
      responseData = action.response && action.response.data
      reducerState.storyblokBlogHomeData = responseData && responseData.story
      break
    case LOAD_SB_BLOG_HOME_DATA[FAILURE]:
      reducerState.isFetchingBlogHome = false
      break


      // Store Most Popular posts for blog home page
      // case LOAD_SB_MOST_POPULAR_POSTS_DATA[REQUEST]:
      //   reducerState.isFetchingPopularPostList = true
      //   reducerState.popularPostList = null
      //   break
      // case LOAD_SB_MOST_POPULAR_POSTS_DATA[SUCCESS]:
      //   reducerState.isFetchingPopularPostList = false
      //   responseData = action.response && action.response.data
      //   reducerState.popularPostList = responseData && responseData.stories
      //   break
      // case LOAD_SB_MOST_POPULAR_POSTS_DATA[FAILURE]:
      //   reducerState.isFetchingPopularPostList = false
      //   break

    // Store Latest posts for blog home page
    case LOAD_SB_LATEST_POSTS_DATA[REQUEST]:
      reducerState.isFetchingLatestPostList = true
      reducerState.latestPostList = null

      reducerState.latestPostListPagination = {
        ...reducerState.latestPostListPagination,
        currentPage: action.page || 1,
      }
      break
    case LOAD_SB_LATEST_POSTS_DATA[SUCCESS]:
      reducerState.isFetchingLatestPostList = false
      responseData = action.response && action.response.data

      reducerState.latestPostListPagination = {
        ...reducerState.latestPostListPagination,
        total: action.response?.headers?.total,
        perPage: action.response?.headers?.['per-page'],
      }
      reducerState.latestPostList = responseData && responseData.stories
      break
    case LOAD_SB_LATEST_POSTS_DATA[FAILURE]:
      reducerState.isFetchingLatestPostList = false
      break

    // Store related posts data
    case LOAD_SB_RELATED_POSTS_DATA[REQUEST]:
      reducerState.isFetchingRelatedPostList = true
      reducerState.relatedPostsList = null
      break
    case LOAD_SB_RELATED_POSTS_DATA[SUCCESS]:
      reducerState.isFetchingRelatedPostList = false
      responseData = action.response && action.response.data
      reducerState.relatedPostsList = responseData && responseData.stories
      break
    case LOAD_SB_RELATED_POSTS_DATA[FAILURE]:
      reducerState.isFetchingRelatedPostList = false
      break
  }
  return reducerState
}

export default storyblokReducer
